import { UserState } from '@/redux/slices/user/types';
import { buildURL, patch, post } from '@/shared/fetch';

import {
  PatchUserProfileRequest,
  PatchUserRequest,
  PostUserPasswordRequest,
  TourOnboardingRequest,
  UpdateMarketingOptInRequest,
} from './types';

export const patchUserProfileMutationFn = async (args: PatchUserProfileRequest) => {
  const { timeZone: timezone } = Intl.DateTimeFormat().resolvedOptions();
  return patch(buildURL('/users/profile'), {
    ...args,
    timezone,
  });
};

export const postUserMarketingOptInMutationFn = async (args: UpdateMarketingOptInRequest) => {
  return post(buildURL('/users/account/marketing'), args);
};

export const postUserAppOnboardedMutationFn = async () => {
  return post(buildURL('/users/steps'), { step: 'isAppOnboarded', value: true });
};

export const patchUserMutationFn = async (args: PatchUserRequest) => {
  return patch<Partial<UserState>>(buildURL('/users/me'), args);
};

export const postTourOnboardingMutationFn = async (args: TourOnboardingRequest) => {
  return post<{ user: Partial<UserState> }>(buildURL('/users/tourOnboarding'), args);
};

export const postRedeemCode = async (code: string) => {
  return post<{ user: Partial<UserState>; productId: string; price: number; status: string }>(buildURL('/redeem'), { code });
};

export const postUserPasswordMutationFn = async (args: PostUserPasswordRequest) => {
  return post<{ user: Partial<UserState> }>(buildURL('/users/account/password'), args);
};

export const postResetPasswordMutationFn = async (email: string) => {
  return post(buildURL('/users/password/reset'), {
    email,
    origin: window.location.origin,
  });
};
